import React from 'react';

const Testimonials = () => {
    const reviews = [
        {
            name: "Chamari Perera",
            date: "2 months ago",
            rating: 5,
            text: "Dr. Lakruwan is an amazing doctor! I went for a root canal and I was very nervous, but the procedure was completely painless. The clinic is so clean and has a very calming atmosphere. Highly recommend for anyone in Kottawa!",
            initial: "C"
        },
        {
            name: "Nuwan Pradeep",
            date: "1 month ago",
            rating: 5,
            text: "Best dental experience I have ever had. The staff is very friendly and efficient. They explained everything clearly before the treatment. Very reasonable prices for such a premium service. Thank you Smile Care!",
            initial: "N"
        },
        {
            name: "Dilini Jayawardena",
            date: "3 weeks ago",
            rating: 5,
            text: "Very professional service. I did a teeth whitening session here and the results are fantastic! The place is spotless and follows all covid safety guidelines. Parking is also available.",
            initial: "D"
        }
    ];

    return (
        <section className="py-12 md:py-24 bg-slate-50 dark:bg-slate-900 overflow-hidden" id="reviews">
            <div className="container mx-auto px-6 md:px-12">

                {/* Header with Google Badge */}
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-white dark:bg-slate-800 rounded-full shadow-sm border border-slate-200 dark:border-slate-700 mb-6">
                        <i className="fab fa-google text-[#4285F4] text-lg"></i>
                        <span className="text-sm font-semibold text-slate-700 dark:text-slate-300">
                            4.9/5 Average Rating
                        </span>
                    </div>

                    <h2 className="font-display text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white mb-6">
                        Trusted by <span className="text-primary">Happy Patients</span>
                    </h2>
                    <p className="text-lg text-slate-600 dark:text-slate-400 font-light leading-relaxed">
                        See what our community in Kottawa has to say about their experience at Smile Care.
                    </p>
                </div>

                {/* Reviews Grid - Adjusted heights and removed Italics */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
                    {reviews.map((review, index) => (
                        <div key={index} className="bg-white dark:bg-slate-800 p-8 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-slate-100 dark:border-slate-700 flex flex-col relative group h-auto">
                            {/* Google Indicator */}
                            <div className="absolute top-6 right-6 text-slate-100 dark:text-slate-800 group-hover:text-[#4285F4]/10 transition-colors duration-300">
                                <i className="fab fa-google text-3xl"></i>
                            </div>

                            {/* Stars */}
                            <div className="flex gap-1 text-[#F4B400] mb-5 text-sm">
                                {[...Array(review.rating)].map((_, i) => (
                                    <i key={i} className="fas fa-star"></i>
                                ))}
                            </div>

                            {/* Text - Clean, Non-Cursive font */}
                            <p className="text-slate-600 dark:text-slate-300 mb-6 leading-relaxed text-[15px] font-normal font-body">
                                "{review.text}"
                            </p>

                            {/* Author */}
                            <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-50 dark:border-slate-700/50">
                                <div className="w-10 h-10 bg-primary/10 text-primary rounded-full flex items-center justify-center font-bold text-sm">
                                    {review.initial}
                                </div>
                                <div>
                                    <h4 className="font-bold text-slate-900 dark:text-white text-sm">{review.name}</h4>
                                    <span className="text-slate-400 text-xs">{review.date}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* CTA Button - Subtle Outline Style */}
                <div className="flex justify-center">
                    <a
                        href="https://maps.app.goo.gl/jATAtdUR4qQrAhtS6"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-slate-600 dark:text-slate-300 hover:text-primary dark:hover:text-primary font-medium transition-colors duration-300 group text-sm"
                    >
                        <span className="border-b border-transparent group-hover:border-primary pb-0.5">
                            Read more reviews on Google Maps
                        </span>
                        <i className="fas fa-arrow-right text-xs transform group-hover:translate-x-1 transition-transform"></i>
                    </a>
                </div>

            </div>
        </section>
    );
};

export default Testimonials;
